// eslint-disable-next-line import/prefer-default-export
export const SET_USER = 'AUTH/SET_USER'
